import { Utilities } from "../../../../utils/utilities";
import CollectionLoader from "../../General/CollectionLoader";
import { DataSource } from "../../General/DataSource";
import { ReadAccess } from "../../General/AccessData";
import { FirebaseData } from "../../General/FirebaseData";
import { PropertyData } from "../PropertyData";
import { CollectionItemDeviationData } from "./CollectionItemDeviationData";
import { CollectionItemRoutineData } from "./CollectionItemRoutineData";

export class PropertyCollectionItemData extends FirebaseData {
  name: string = "";
  fields: {
    [key: string]: DataSource;
  } = {};
  routines: CollectionLoader<CollectionItemRoutineData>;
  deviations: CollectionLoader<CollectionItemDeviationData>;
  readAccess: ReadAccess = {};
  writeAccess: ReadAccess | undefined = undefined;
  propertyFileIDs: string[] = [];
  fileIDs: string[] = [];

  archived: boolean = false;

  constructor(id: string, collectionName: string, parent: FirebaseData | undefined) {
    super(id, collectionName, parent);
    this.routines = new CollectionLoader("routines", this, CollectionItemRoutineData);
    this.deviations = new CollectionLoader("deviations", this, CollectionItemDeviationData);
  }

  setup(data: any) {
    this.name = typeof data.name === "string" ? data.name : "";

    this.fields = {};
    if (typeof data.fields === "object") {
      for (const key of Object.keys(data.fields)) {
        const dataSource = DataSource.getDataSource(data.fields[key]);
        if (dataSource) {
          this.fields[key] = dataSource;
        }
      }
    }
    this.readAccess = Utilities.getReadAccess(data.readAccess);
    this.writeAccess = Utilities.getOptionalReadAccess(data.writeAccess);

    this.propertyFileIDs = Array.isArray(data.propertyFileIDs) ? data.propertyFileIDs : [];
    this.fileIDs = Array.isArray(data.fileIDs) ? data.fileIDs : [];

    this.archived = typeof data.archived === "boolean" ? data.archived : false;

    super.setup(data);
  }

  archive() {
    const newArchiveStatus = !this.archived;
    return this.saveUpdate({ archived: newArchiveStatus }).then(() => {
      this.archived = newArchiveStatus;
    });
  }

  hasReadAccess() {
    const property = this.parent?.parent instanceof PropertyData ? this.parent.parent : undefined;
    return Utilities.hasAccess(this.readAccess, property?.id);
  }

  hasWriteAccess() {
    const property = this.parent?.parent instanceof PropertyData ? this.parent.parent : undefined;
    if (this.writeAccess) {
      return Utilities.hasAccess(this.writeAccess, property?.id);
    }
    return Utilities.hasAccess(this.readAccess, property?.id);
  }
}
